import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { RatingLabelStyled, Name, Value } from './styles/RatingLabelStyled';

const RatingLabel = ({ name, value }) => (
  <RatingLabelStyled>
    <Value>{value}</Value>
    <Name>{name}</Name>
  </RatingLabelStyled>
);

RatingLabel.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

RatingLabel.defaultProps = {};

export default memo(RatingLabel);
